const ui = {
  black: "#000000",
  white: "#ffffff",
  error: "#97272c",
  link: {
    primary: "#0576d3",
    secondary: "#004b98"
  },
  disabled: {
    primary: "#e0e0e0",
    secondary: "#004b98"
  },
  gray: {
    extraDark: "#424242",
    dark: "#616161",
    medium: "#bdbdbd",
    light: "#e0e0e0",
    lightWarm: "#EFEDEB",
    extraLight: "#f5f5f5",
    extraLightWarm: "#f8f8f7",
    extraExtraLight: "#fafafa"
  },
  blue: {
    focus: "#007AFF",
    light: "#43BAE6"
  },
  green: {
    success: "#32855D"
  }
};

const brand = {
  primary: "#377F8B",
  secondary: "#D53F34"
};

const colors = {
  // body color
  text: ui.black,
  // body background color
  background: ui.white,
  ui,
  brand
};

export default colors;
